<template>
	<v-card class="settings-page pa-7 pb-1 mt-8 pb-8" style="border-radius: 10px; max-width: 600px;" flat>
		<v-card-text class='mt-5'>
			<div class='justify-space-between d-flex'>
				<div
					class='mb-4 d-flex'
					@click='$router.go(-1)'
				>
					<v-icon size="22" class='mr-2'> mdi-arrow-left-circle</v-icon>
					<div class='event-card__link'>Profile</div>
				</div>
				<div class="d-flex justify-space-between">
					<div class="d-flex w-100 mr-6 align-center" style="width: 100%">
						<input
							type="text"
							class="post-preview-card__comment px-3 py-2"
							placeholder="Search"
							v-model="filters.search"
							@input="filterSearch"
							style="border: 1px solid lightgrey; border-radius: 20px;"
						/>
					</div>
					<img :src="searchIcon" alt="" />
				</div>
			</div>

			<div class='justify-space-between d-flex mt-4'>
				<h2 class='mb-4 d-flex'>
					Bookmarks
				</h2>
			</div>

			<v-skeleton-loader
				style="max-width: 600px;"
				v-bind="attrs"
				type="card"
				v-if="isLoading"
			>
			</v-skeleton-loader>

			<BookmarkList
				v-if='!isLoading && bookmarksList.length > 0'
				:resourcesItems="bookmarks"
			/>

			<div
				v-if="!isLoading && bookmarksList.length <= 0"
				class="mt-5 align-center"
			>
				<NewsFeedEmpty
					title="Bookmarks is empty at the moment."
					description="Check back later."
				/>
			</div>
			<div
				class="d-flex mt-5 mb-2 ma-auto justify-center home-page__pagination"
				v-if="!isLoading && bookmarksList.length > 0"
			>
				<v-pagination
					color="#F2F2F2"
					:total-visible="10"
					circle
					v-model="filters.page"
					:length="pageCount"
					@input="(e) => onPageChange(e)"
				></v-pagination>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import resourceFolderIcon from '@/assets/images/recource-folder-icon.svg'
import searchIcon from '@/assets/images/search.svg'
import FeaturedPost from '@/components/Post/PostFeaturedPreview.vue'
import BookmarkList from '@/components/Profile/BookmarkList.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'

export default {
	name: 'ProfileBookmarksPage',
	components: {
		NewsFeedEmpty,
		FeaturedPost,
		BookmarkList,
		searchIcon
	},
	computed: {
		...mapGetters('profile', ['bookmarks', 'bookmarksMeta', 'isLoading']),

		bookmarksList() {
			if (this.bookmarks.length <= 0) {
				return []
			}

			return this.bookmarks;
		},
		pageCount() {
			if (!this.bookmarksMeta) {
				return 0;
			}

			return this.bookmarksMeta.pageCount
		}
	},
	methods: {
		...mapActions('profile', ['getProfileBookmarks', 'clearBookmarks']),

		onPageChange(page) {
			const params = {
				search: this.filters.search,
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getResources(queryString)
		},
		getResources(queryString) {
			this.getProfileBookmarks(queryString)
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getResources(queryString)
			}, 500)
		},
		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
	},
	data() {
		return {
			resourceFolderIcon,
			searchIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
		}
	},
	created() {
		!this.bookmarks.length && this.getProfileBookmarks()
	},
	beforeDestroy() {
		this.clearBookmarks()
	}
}
</script>

<style lang="scss">
.settings-page {
	&.v-tabs {
		font-style: normal;
		font-weight: bold !important;
		font-size: 20px;
		line-height: 67px;
		text-transform: capitalize;
		justify-content: space-between;
		letter-spacing: 0.1px !important;
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	&__tabs {
		.v-tab {
			justify-content: space-between;
			font-style: normal;
			font-weight: 900;
			font-size: 20px;
			line-height: 67px;
			text-transform: capitalize;
			color: #cbcbcb !important;

			&--active {
				color: #4d536e !important;
			}
		}
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
		.v-tabs-bar {
			display: contents;
		}
		.v-tab {
			font-size: 18px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
		.v-tab {
			padding: 0 3px;
		}
	}
}
</style>
